import { Injectable } from '@angular/core';
import { RegionMapEditorHubDto } from 'app/models/region-map-editor/hub-model';
import { GeoZoneStatusDto, GeoZoneStatusRequestDto, ServiceableRequestDto } from 'app/models/region-map-editor/map-editor';
import { DeletePoiRequest, GetPoiResponse, RegionMapEditorPOIDto, SavePoiRequest } from 'app/models/region-map-editor/poi-model';
import { GetPointResponse, SavePointRequest } from 'app/models/region-map-editor/save-point';
import { CreateAmenityRequest } from 'app/models';
import { ApiHttp } from 'app/providers';
import { MessageService } from 'primeng/api';


@Injectable()
export class RegionMapEditorService {
    constructor(private apiHttp: ApiHttp) {
    }

    public getGeoZonesStatus(data: GeoZoneStatusDto, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminRegionMapEditor/GetGeoZonesStatus', data, messageService);
    }

    public toggleGeoZoneStatus(data: GeoZoneStatusRequestDto, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminRegionMapEditor/ToggleGeoZoneStatus', data, messageService);
    }
    public toggleServiceableArea(data: ServiceableRequestDto, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminRegionMapEditor/ToggleServiceableArea', data, messageService);
    }

    public getLocationZones(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminRegionMapEditor/getLocationZones', data, messageService);
    }

    public saveLocationZone(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminRegionMapEditor/saveLocationZone', data, messageService);
    }

    public editLocationZone(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminRegionMapEditor/editLocationZone', data, messageService);
    }

    public deleteLocationZone(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminRegionMapEditor/deleteLocationZone', data, messageService);
    }

    public saveHub(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminRegionMapEditor/saveHub', data, messageService);
    }

    public getHubs(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminRegionMapEditor/getHubs', data, messageService);
    }

    public editHub(data: RegionMapEditorHubDto, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminRegionMapEditor/editHub', data, messageService);
    }

    public deleteHub(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminRegionMapEditor/deleteHub', data, messageService);
    }

    public savePoint(data: SavePointRequest, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminRegionMapEditor/SavePoint', data, messageService);
    }

    public updatePoint(data: SavePointRequest, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminRegionMapEditor/EditPoint', data, messageService);
    }

    public deletePoint(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminRegionMapEditor/DeletePoint', data, messageService);
    }

    public getPoints(data: any, messageService: MessageService): Promise<GetPointResponse> {
        return this.apiHttp.post('api/AdminRegionMapEditor/GetPoints', data, messageService);
    }

    public savePoi(data: SavePoiRequest, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminRegionMapEditor/savePoi',data,messageService);
    }

    public editPoi(data: RegionMapEditorPOIDto, messageService: MessageService): Promise<any>{
        return this.apiHttp.post('api/AdminRegionMapEditor/editPoi', data, messageService);
    }

    public getPoi(data: any, messageService: MessageService): Promise<GetPoiResponse> {
        return this.apiHttp.post('api/AdminRegionMapEditor/getPoi', data, messageService);
    }

    public deletePoi(data: DeletePoiRequest, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/AdminRegionMapEditor/deletePoi', data, messageService);
	}

	public getAmenities(data: any, messageService: MessageService): Promise<any> {
		return this.apiHttp.post('api/AdminRegionMapEditor/GetAmenities', data, messageService);
	}

	public createAmenity(data: CreateAmenityRequest, messageService: MessageService): Promise<any> {
		return this.apiHttp.post('api/AdminRegionMapEditor/CreateAmenity', data, messageService);
	}
}
